import { VERIFICATION_BASE_API_URL } from "config/apiUrls";
import { request } from "utils/request";
const VERIFICATION_URL = `${VERIFICATION_BASE_API_URL}/verification`;
export async function uploadVerificationAddressProof({formData, cb = () => null}) {
    const requestUrl = `${VERIFICATION_URL}/verification-document-upload`;
    const options = {
        formdata: formData,
    }
    const result = await request(requestUrl, options);
    return result
}
